import { LocalPreferences } from '@/core/preferences/local-preferences';
import { LocalStorageService } from '@/shared/storage/export';
import { MessageConnectionType } from '@/core/preferences/message-connection-type';
import { getDefaultThemeForHost } from '@/shared/theme/export';

const PREFERENCES_KEY = 'userPreferences';

const storageService = new LocalStorageService();

export const defaultPreferences = (): LocalPreferences => {
  return {
    timezoneType: 'local',
    contrastingColors: 'orange-blue',
    showFlags: true,
    messageConnectionType: MessageConnectionType.WEBSOCKET,
    theme: getDefaultThemeForHost(),
    lastUpdated: new Date(),
    timezone: 'America/New_York',
    globalTextScale: 100,
  };
};

function migrateLegacyTheme(preferences: LocalPreferences): boolean {
  const theme = preferences.theme as unknown as string;

  if (theme === 'alphaflash') {
    preferences.theme = 'light';
    return true;
  }

  if (theme === 'alphaflash-dark') {
    preferences.theme = 'dark';
    return true;
  }

  return false;
}

async function getLocalPreferences(): Promise<LocalPreferences> {
  let preferences = await storageService.getValue<LocalPreferences>(PREFERENCES_KEY);

  if (!preferences) {
    preferences = defaultPreferences();
    await saveLocalPreferences(preferences);
  } else if (migrateLegacyTheme(preferences)) {
    await saveLocalPreferences(preferences);
  }

  return preferences;
}

async function saveLocalPreferences(localPreferences: LocalPreferences): Promise<LocalPreferences> {
  localPreferences.lastUpdated = new Date();
  await storageService.saveValue(PREFERENCES_KEY, localPreferences);

  console.log('PREFERENCES', localPreferences);

  return getLocalPreferences();
}

async function updateLocalPreferences(
  callback: (localPreferences: LocalPreferences) => Promise<LocalPreferences>,
): Promise<LocalPreferences> {
  let preferences = await getLocalPreferences();

  preferences = await callback(preferences);

  return saveLocalPreferences(preferences);
}
// eslint-disable-next-line
export default {
  updateLocalPreferences,
  getLocalPreferences,
};
